<template>
    <div>
        <div>
            <div class="header-title" v-if="indexArr == 'a'">
                考核内容：获得山地模型。请制作1：1000的数字正射影像图，并提供相应的数字表面模型和三维模型。你有2个小时完成此次任务。出发吧，飞行者({{titleModel}})！
            </div>
            <div class="header-title" v-if="indexArr == 'b'">
                考核内容：获得良乡学院模型。请制作1：400的数字正射影像图，并提供相应的数字表面模型和三维模型。你有2个小时完成此次任务。出发吧，飞行者({{titleModel}})！
            </div>
            <div v-if="activeIndex === -1">
                <model-viewer  @loaded="handleLoaded()" :folder="randomFolder()"></model-viewer>
            </div>

            <div class="bottomButton">
            </div>
            <div style="position: absolute;top: 30%;margin-top: -70px;width: 13.5%;">
                <vNav :indexArr="indexArr" :model="model" :rule="rule" @qifei="switchLabel"
                      @kongzhi="switchLocation"></vNav>
            </div>
            <!-- TODO iframe嵌套div -->

            <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="ifShowIframe"
                       width="80%" top="10vh">
                <!--TODO 拍摄判断-->
                <div class="mdk-sheying"
                     v-if="src == 'https://e.modocker.com/link/?id=AA3iiXelzYagGWEdZa389OX7JzdwDme1&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1' && ifPaisheLoaded">
                    <div style="display: inline-block;">
                        <img :src="'/../../../static/img/sheying/DSC_01' + imgIndex + '[1472x982].jpg'" height="200px"
                             width="300px" alt="">
                    </div>
                    <div style="display: inline-block;text-align:right;width:calc(100% - 300px);height:200px;vertical-align:top;">
                        接口传过来的文字（当前电量%%%，飞行速度%%%）
                    </div>
                </div>

                <iframe :src="src" class="mdk-main-iframe" frameborder="0" scrolling="no" seamless allowvr
                        allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe>
                <div v-if="activeIndex == 0" style="width:100%;text-align: center !important;margin-top: 16px;">
                    <el-button type="primary" style="width: 128px !important;">起飞</el-button>
                    <el-button type="primary" style="width: 128px !important;" @click="handleQifei(1)">拍摄</el-button>
                    <el-button type="primary" style="width: 128px !important;" @click="handleQifei(2)">降落</el-button>
                </div>
            </el-dialog>
            <el-tooltip effect="dark" content="地势较高，平坦，人烟稠密，周边有高大建筑物。在测区中部。" placement="right">
                <i class="el-icon-location mdk-location" @click="TakeOff(0)" id="qifeiA">
                    <span style="color: black">起飞点A</span>
                </i>
            </el-tooltip>
            <el-tooltip effect="dark" content="局部平坦，人烟稀少，在沟谷之中，视线受阻。在测区边缘。" placement="right">
                <i class="el-icon-location mdk-location" @click="TakeOff(1)" id="qifeiB">
                    <span style="color: black">起飞点B</span>
                </i>
            </el-tooltip>
            <el-tooltip effect="dark" content="地势较高，平坦，视野开阔，人烟稀少。在测区中部。" placement="right">
                <i class="el-icon-location mdk-location" @click="TakeOff(2)" id="qifeiC">
                    <span style="color: black">起飞点C</span>
                </i>
            </el-tooltip>
            <el-tooltip effect="dark" content="在厂区附近的平坦地面，地势低洼，有高压线塔，人员较为密集。" placement="right">
                <i class="el-icon-location mdk-location" @click="TakeOff(3)" id="qifeiD">
                    <span style="color: black">起飞点D</span>
                </i>
            </el-tooltip>
            <el-tooltip effect="dark" content="地势较高，平坦，视野开阔，人烟稀少。" placement="right">
                <i class="el-icon-location mdk-location" @click="TakeOff(4)" id="qifeiE">
                    <span style="color: black">起飞点E</span>
                </i>
            </el-tooltip>
            <i class="el-icon-location mdk-location" id="kongzhi1-1"></i>
            <i class="el-icon-location mdk-location" id="kongzhi1-2"></i>
            <i class="el-icon-location mdk-location" id="kongzhi1-3"></i>
            <i class="el-icon-location mdk-location" id="kongzhi1-4"></i>
            <i class="el-icon-location mdk-location" id="kongzhi1-5"></i>
            <i class="el-icon-location mdk-location" id="kongzhi2-1"></i>
            <i class="el-icon-location mdk-location" id="kongzhi2-2"></i>
            <i class="el-icon-location mdk-location" id="kongzhi2-3"></i>
            <i class="el-icon-location mdk-location" id="kongzhi2-4"></i>
            <i class="el-icon-location mdk-location" id="kongzhi2-5"></i>
        </div>
        <div style="position: absolute;right: 10px;top:50%;margin-top: -40px;">
            <el-button type="primary" @click="repload()">更换任务-场景</el-button>
        </div>
    </div>
</template>

<script>
    import vNav from './newNav/index'
    import ModelViewer from '@/components/3D/ModelViewer.vue'

    export default {
        components: {
            vNav, ModelViewer
        },
        data() {
            return {
                clickBoolean: false,
                titleModel: "",
                model: '',//天气
                rule: '',
                optionIds: [],
                activeIndex: -1,
                iframe: '',
                ifShowIframe: false,
                src: undefined,
                imgIndex: 43,
                ifPaisheLoaded: false,
                indexArr: 'a',
            };
        },
        methods: {
            handleLoaded(){
                scene.moSpecial.cameraSettings({ left: 120, right:120, up: 80, down: 80, in: 0, out: 0});
            },
            //随机天气效果
            randomFolder() {
                // <model-viewer>组件用于显示本地static/model文件夹中的模型文件，接收一个folder属性，也就是static/model文件夹下不同模型的文件夹的名字字符串，当folder发生变化时，将会自动重载模型
                // static/model 文件夹下的模型对应关系:
                // YukkuzToR8zA7u4khCiwM9YQdH19aFZY  --  旧地形模型，已废弃
                // Af4wxg641tYeEpB3rEiY5NGBJ1l6VKfO  --  无天气效果的默认模型

                //5Heq5s3Zo18XX1wW0nK3yQR97sssCb9v  大风
                // LJy23oW1mn2OLfFI11Fw4k13U9NNne66 微风
                //nTvQyAF3WjRhP76ybn5R8WCJ73320GPkqiang  强风
                // z71Lc281UVryH08vvqug8fwTS3GV91Dg  --  阳光明媚:非常适合飞行
                // nTvQyAF3WjRhP76ybn5R8WCJ73320GPk  --  强风5级以上:不适合飞行
                // xV4iX0odzNK7Yka1wq9J99F9DQI40786  --  微风阴天:适合飞行
                // Ad3DA0SPluM7wTzbG32h9u8WFG2uiFrZ  --  大风:勉强适合飞行
                /**随机 */
                let index = Math.floor((Math.random() * 2) + 1)
                // let index = 2
                // console.log(index)
                if (index == 1) {
                    this.indexArr = 'a'
                } else {
                    this.indexArr = 'b'
                }


                if (index == 1) {
                    const model = ['z71Lc281UVryH08vvqug8fwTS3GV91Dg', 'nTvQyAF3WjRhP76ybn5R8WCJ73320GPk', 'xV4iX0odzNK7Yka1wq9J99F9DQI40786', 'Ad3DA0SPluM7wTzbG32h9u8WFG2uiFrZ']
                    this.model = model[Math.floor((Math.random() * 4) + 1) - 1]

                    if (this.model == 'z71Lc281UVryH08vvqug8fwTS3GV91Dg') {
                        this.titleModel = '阳光明媚 ,天气效果:二级清风叶正响'
                    } else if (this.model == 'nTvQyAF3WjRhP76ybn5R8WCJ73320GPk') {
                        this.titleModel = '微风阴天 ,天气效果:三级枝摇红旗扬'
                    } else if (this.model == 'Ad3DA0SPluM7wTzbG32h9u8WFG2uiFrZ') {
                        this.titleModel = '大风 ,天气效果:四级灰尘地上舞'
                    } else if (this.model == 'xV4iX0odzNK7Yka1wq9J99F9DQI40786') {
                        this.titleModel = '强风 ,天气效果:八级风吹树枝断'

                    }
                    return model[Math.floor((Math.random() * 4) + 1) - 1]

                } else {
                    const newModel = ['5Heq5s3Zo18XX1wW0nK3yQR97sssCb9v', 'LJy23oW1mn2OLfFI11Fw4k13U9NNne66', 'YKSkz6Grc1BMJ7K9dsQw4iIUBVbArMm5', 'g3I05v7773ny21gFgfc5tqGZV4tB5gRJ']
                    let bbb = newModel[Math.floor((Math.random() * 4) + 1) - 1]
                    if (bbb == 'g3I05v7773ny21gFgfc5tqGZV4tB5gRJ') {
                        this.titleModel = '阳光明媚 ,天气效果:二级清风叶正响'
                    } else if (bbb == 'LJy23oW1mn2OLfFI11Fw4k13U9NNne66') {
                        this.titleModel = '微风阴天 ,天气效果:三级枝摇红旗扬'
                    } else if (bbb == '5Heq5s3Zo18XX1wW0nK3yQR97sssCb9v') {
                        this.titleModel = '大风 ,天气效果:四级灰尘地上舞'
                    } else if (bbb == 'YKSkz6Grc1BMJ7K9dsQw4iIUBVbArMm5') {
                        this.titleModel = '强风 ,天气效果:八级风吹树枝断'

                    }

                    return newModel[Math.floor((Math.random() * 4) + 1) - 1]
                }


            },
            //点击起飞按钮
            TakeOff(index) {
                if (index === 0) {

                } else if (index === 1) {

                } else {

                }
            },
            reloads() {

                if (this.clickBoolean) {
                    window.location.reload()
                }
            },
            switchLocation(val) {
                document.getElementById('qifeiA').style.visibility = 'hidden'
                document.getElementById('qifeiB').style.visibility = 'hidden'
                document.getElementById('qifeiC').style.visibility = 'hidden'
                document.getElementById('qifeiD').style.visibility = 'hidden'
                document.getElementById('qifeiE').style.visibility = 'hidden'
                const location = {
                    model:{
                        kongzhi1_1: {
                            x: -11.143283617021865,
                            y: 0.504385864961,
                            z: 5.031510044805437,
                        },
                        kongzhi1_2: {
                            x: -11.147621450651236,
                            y: 0.503560438586496,
                            z: -5.035604385864961,
                        },
                        kongzhi1_3: {
                            x: 10.064260153929933,
                            y: 0.6,
                            z: -5.0797926571141485,
                        },
                        kongzhi1_4: {
                            x: 10.256623301746378,
                            y: 0.70021722772172197,
                            z: 5.084377796384926,
                        },
                        kongzhi1_5: {
                            x: -1.2077094024535615,
                            y: 0.70021722772172197,
                            z: 0.9,
                        },
                        kongzhi2_1: {
                            x: -1.8714690765314119,
                            y: 0.7035000957854585,
                            z: 5.145089258949655,
                        },
                        kongzhi2_2: {
                            x: -1.2077094024535615,
                            y: 0.70021722772172197,
                            z: 0.9,
                        },
                        kongzhi2_3: {
                            x: 1.520807409778279,
                            y: 0.60260581988590616,
                            z: -3.021063869508442,
                        },
                        kongzhi2_4: {
                            x: 9.008521945444123,
                            y: 0.5461768547206148,
                            z: -2.5716240022501553,
                        },
                        kongzhi2_5: {
                            x: 6.946333157295761,
                            y: 0.7387567632211713,
                            z: 2.3958603626477686,
                        },
                    },
                    CNU: {
                        kongzhi1_1: {
                            x: -10.143283617021865,
                            y: 0.0293173667567835,
                            z: 8.631510044805437,
                        },
                        kongzhi1_2: {
                            x: -10.147621450651236,
                            y: 0.2709856914336619,
                            z: -5.035604385864961,
                        },
                        kongzhi1_3: {
                            x: 10.064260153929933,
                            y: 0.49976057078316458,
                            z: -5.0797926571141485,
                        },
                        kongzhi1_4: {
                            x: 7.256623301746378,
                            y: 0.32776593152090925,
                            z: 5.684377796384926,
                        },
                        kongzhi1_5: {
                            x: 0.22077094024535615,
                            y: 0.3521722772172197,
                            z: 0.53231539786465616,
                        },
                        kongzhi2_1: {
                            x: 3.0714690765314119,
                            y: 0.4535000957854585,
                            z: 5.245089258949655,
                        },
                        kongzhi2_2: {
                            x: 0.22077094024535615,
                            y: 0.4021722772172197,
                            z: 0.53231539786465616,
                        },
                        kongzhi2_3: {
                            x: 5.220807409778279,
                            y: 0.45260581988590616,
                            z: -5.021063869508442,
                        },
                        kongzhi2_4: {
                            x: 7.508521945444123,
                            y: 0.3461768547206148,
                            z: -2.3716240022501553,
                        },
                        kongzhi2_5: {
                            x: 6.946333157295761,
                            y: 0.3387567632211713,
                            z: 2.3958603626477686,
                        },
                    },
                }
                switch (val) {
                    case 1:
                        var location_path=location
                        for(let material of scene.materials){
                            if(material.emissiveTexture && material.albedoTexture.name){
                                let name = material.albedoTexture.name.split('/').reverse()[0].split('_')[0]
                                if(name=="model"){
                                    // console.log(name,val)
                                    location_path=location.model
                                    // if(material.emissiveTexture.name!='/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg'){
                                    //     material.emissiveTexture=new BABYLON.Texture(
                                    //         // '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                                    //         '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                                    // }
                                }
                                if(name=="CNU"){
                                    // console.log(name,val)
                                    location_path=location.CNU
                                    // if(material.emissiveTexture.name!='/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg'){
                                    //     material.emissiveTexture=new BABYLON.Texture(
                                    //         '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                                    //         // '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                                    // }
                                }
                            }
                        }
                        scene.moSpecial.addLabel(location_path.kongzhi1_1.x, location_path.kongzhi1_1.y, location_path.kongzhi1_1.z, document.getElementById('kongzhi1-1'));
                        scene.moSpecial.addLabel(location_path.kongzhi1_2.x, location_path.kongzhi1_2.y, location_path.kongzhi1_2.z, document.getElementById('kongzhi1-2'));
                        scene.moSpecial.addLabel(location_path.kongzhi1_3.x, location_path.kongzhi1_3.y, location_path.kongzhi1_3.z, document.getElementById('kongzhi1-3'));
                        scene.moSpecial.addLabel(location_path.kongzhi1_4.x, location_path.kongzhi1_4.y, location_path.kongzhi1_4.z, document.getElementById('kongzhi1-4'));
                        scene.moSpecial.addLabel(location_path.kongzhi1_5.x, location_path.kongzhi1_5.y, location_path.kongzhi1_5.z, document.getElementById('kongzhi1-5'));
                        document.getElementById('kongzhi1-1').style.visibility = 'visible'
                        document.getElementById('kongzhi1-2').style.visibility = 'visible'
                        document.getElementById('kongzhi1-3').style.visibility = 'visible'
                        document.getElementById('kongzhi1-4').style.visibility = 'visible'
                        document.getElementById('kongzhi1-5').style.visibility = 'visible'
                        document.getElementById('kongzhi2-1').style.visibility = 'hidden'
                        document.getElementById('kongzhi2-2').style.visibility = 'hidden'
                        document.getElementById('kongzhi2-3').style.visibility = 'hidden'
                        document.getElementById('kongzhi2-4').style.visibility = 'hidden'
                        document.getElementById('kongzhi2-5').style.visibility = 'hidden'
                        break;
                    case 2:
                        var location_path=location
                        for(let material of scene.materials){
                            if(material.emissiveTexture && material.albedoTexture.name){
                                let name = material.albedoTexture.name.split('/').reverse()[0].split('_')[0]
                                if(name=="model"){
                                    // console.log(name,val)
                                    location_path=location.model
                                    // if(material.emissiveTexture.name!='/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg'){
                                    //     material.emissiveTexture=new BABYLON.Texture(
                                    //         // '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                                    //         '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                                    // }
                                }
                                if(name=="CNU"){
                                    // console.log(name,val)
                                    location_path=location.CNU
                                    // if(material.emissiveTexture.name!='/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg'){
                                    //     material.emissiveTexture=new BABYLON.Texture(
                                    //         '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                                    //         // '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                                    // }
                                }
                            }
                        }
                        scene.moSpecial.addLabel(location_path.kongzhi2_1.x, location_path.kongzhi2_1.y, location_path.kongzhi2_1.z, document.getElementById('kongzhi2-1'));
                        scene.moSpecial.addLabel(location_path.kongzhi2_2.x, location_path.kongzhi2_2.y, location_path.kongzhi2_2.z, document.getElementById('kongzhi2-2'));
                        scene.moSpecial.addLabel(location_path.kongzhi2_3.x, location_path.kongzhi2_3.y, location_path.kongzhi2_3.z, document.getElementById('kongzhi2-3'));
                        scene.moSpecial.addLabel(location_path.kongzhi2_4.x, location_path.kongzhi2_4.y, location_path.kongzhi2_4.z, document.getElementById('kongzhi2-4'));
                        scene.moSpecial.addLabel(location_path.kongzhi2_5.x, location_path.kongzhi2_5.y, location_path.kongzhi2_5.z, document.getElementById('kongzhi2-5'));
                        document.getElementById('kongzhi2-1').style.visibility = 'visible'
                        document.getElementById('kongzhi2-2').style.visibility = 'visible'
                        document.getElementById('kongzhi2-3').style.visibility = 'visible'
                        document.getElementById('kongzhi2-4').style.visibility = 'visible'
                        document.getElementById('kongzhi2-5').style.visibility = 'visible'
                        document.getElementById('kongzhi1-1').style.visibility = 'hidden'
                        document.getElementById('kongzhi1-2').style.visibility = 'hidden'
                        document.getElementById('kongzhi1-3').style.visibility = 'hidden'
                        document.getElementById('kongzhi1-4').style.visibility = 'hidden'
                        document.getElementById('kongzhi1-5').style.visibility = 'hidden'
                        break;
                    default:
                        break;
                }
            },
            switchLabel(id) {
                document.getElementById('kongzhi2-1').style.visibility = 'hidden'
                document.getElementById('kongzhi2-2').style.visibility = 'hidden'
                document.getElementById('kongzhi2-3').style.visibility = 'hidden'
                document.getElementById('kongzhi2-4').style.visibility = 'hidden'
                document.getElementById('kongzhi2-5').style.visibility = 'hidden'
                document.getElementById('kongzhi1-1').style.visibility = 'hidden'
                document.getElementById('kongzhi1-2').style.visibility = 'hidden'
                document.getElementById('kongzhi1-3').style.visibility = 'hidden'
                document.getElementById('kongzhi1-4').style.visibility = 'hidden'
                document.getElementById('kongzhi1-5').style.visibility = 'hidden'
                const label = ['qifeiA', 'qifeiB', 'qifeiC', 'qifeiD', 'qifeiE']
                const location = {
                    model: {
                        qifeiA: {
                            x: 4.080092405419612,
                            y: 0.05,
                            z: -0.6818325306726483,
                        },
                        qifeiB: {
                            x: -8.34276912155324,
                            y: 0.71,
                            z: 2.5660321435475993,
                        },
                        qifeiC: {
                            x: 1.3544799964317729,
                            y: 0.71849505960284361,
                            z: -3.25909964274242,
                        },
                        qifeiD: {
                            x: 7.10566376300548,
                            y: -0.104160350633572,
                            z: -4.689241639893957,
                        },
                        qifeiE: {
                            x: -6.491414620450229,
                            y: 0.7145230321728661,
                            z: 5.384355656547729,
                        },
                    },
                    CNU: {
                        qifeiA: {
                            x: 4.080092405419612,
                            y: 0.2,
                            z: -0.6818325306726483,
                        },
                        qifeiB: {
                            x: -7.434276912155324,
                            y: 0.03288314232358758,
                            z: 3.3660321435475993,
                        },
                        qifeiC: {
                            x: 1.6544799964317729,
                            y: 0.4849505960284361,
                            z: -3.15909964274242,
                        },
                        qifeiD: {
                            x: 7.30566376300548,
                            y: 0.4704160350633572,
                            z: -4.689241639893957,
                        },
                        qifeiE: {
                            x: -10.491414620450229,
                            y: 0.1145230321728661,
                            z: 5.584355656547729,
                        },
                    },
                }
                var location_path=location
                for(let material of scene.materials){
                    if(material.emissiveTexture && material.albedoTexture.name){
                        let name = material.albedoTexture.name.split('/').reverse()[0].split('_')[0]
                        if(name=="model"){
                            // console.log(name,id)
                            location_path=location.model
                            // if(material.emissiveTexture.name!='/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg'){
                            //     material.emissiveTexture=new BABYLON.Texture(
                            //         // '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                            //         '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                            // }
                        }
                        if(name=="CNU"){
                            // console.log(name,id)
                            location_path=location.CNU
                            // if(material.emissiveTexture.name!='/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg'){
                            //     material.emissiveTexture=new BABYLON.Texture(
                            //         '/static/model/LJy23oW1mn2OLfFI11Fw4k13U9NNne66/mobileTexture/CNU_10W.jpg',scene)
                            //         // '/static/model/K2o6YQm3c9l8f7QBnntuE2O6A12359s3/mobileTexture/model_20W.jpg',scene)
                            // }
                        }
                    }
                }
                scene.moSpecial.addLabel(0, 0,0, document.getElementById('qifeiB'));
                scene.moSpecial.addLabel(location_path[id].x, location_path[id].y, location_path[id].z, document.getElementById(id));
                for (var i = 0; i < label.length; i++) {
                    if (id === label[i]) {
                        document.getElementById(label[i]).style.visibility = 'visible'
                    } else {
                        document.getElementById(label[i]).style.visibility = 'hidden'
                    }
                }

            },
            postFunc(func, arg, url, iframe) {

                // 构造信息对象。注意：键值拼写必须如下！
                var msg = {
                    // 调用的函数名称
                    function: func,

                    // 参数
                    arguments: arg
                }


                // 发送信息
                iframe.contentWindow.postMessage(msg, url)
            },
            handleMessage() {
                //接受来自模型iframe的消息，判断是否加载完成
                window.addEventListener('message', (e) => {
                    if (!e.data.type) {
                        return
                    }
                    switch (e.data.type) {

                        case 'Loaded':
                            // if (this.src == 'https://e.modocker.com/link/?id=AA3iiXelzYagGWEdZa389OX7JzdwDme1&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1') {
                            if (this.src =='http://uav.cnuvr.cn/static/model/AA3iiXelzYagGWEdZa389OX7JzdwDme1&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1') {
                                this.ifPaisheLoaded = true
                            }
                            break;
                        case 'LabelList':

                            break;
                        default:
                            return
                    }
                }, false)
            },
            handle(index) {
                if (index === 0) {
                    //起飞
                    this.activeIndex = 0
                    // this.src = 'https://e.modocker.com/link/?id=lIyR6r6Tb4pfqz73M7666bp2El2VCtyI&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.src="http://uav.cnuvr.cn/static/model/lIyR6r6Tb4pfqz73M7666bp2El2VCtyI&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1"
                    this.ifShowIframe = true

                } else if (index === 1) {

                } else {
                    this.goMain('/main')
                }
            },
            handleQifei(index) {
                if (index === 0) {
                    //起飞
                    this.activeIndex = 0
                    // this.src = 'https://e.modocker.com/link/?id=lIyR6r6Tb4pfqz73M7666bp2El2VCtyI&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.src='http://uav.cnuvr.cn/static/model/lIyR6r6Tb4pfqz73M7666bp2El2VCtyI&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.ifShowIframe = true
                } else if (index === 2) {
                    //降落
                    this.optionIds = '23,24'
                    this.select()
                    // this.src = 'https://e.modocker.com/link/?id=agaSKi7Micl4dFnAXFY7iRoKWo5864y7&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.src='http://uav.cnuvr.cn/static/model/agaSKi7Micl4dFnAXFY7iRoKWo5864y7&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.ifShowIframe = true
                } else if (index === 1) {
                    //拍摄
                    this.optionIds = '21,22'
                    this.select()
                    this.src='http://uav.cnuvr.cn/static/model/AA3iiXelzYagGWEdZa389OX7JzdwDme1&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    // this.src = 'https://e.modocker.com/link/?id=AA3iiXelzYagGWEdZa389OX7JzdwDme1&preload=0&logo=0&toolbar=0&rotation=0&autoplay=1'
                    this.ifShowIframe = true
                    setInterval(() => {
                        if (this.imgIndex == 72) {
                            this.imgIndex = 43
                        }
                        this.imgIndex++
                    }, 1000)
                } else {
                    this.goMain('/main')
                }
            },
            //外包id
            getAssessmentId() {
                this.$axios.post(this.URL.uUserTask.assessment).then(res => {
                    if (res.status === 200) {
                        sessionStorage.setItem('AltizureId', res.data.userTaskId)
                    }
                })
            },
            select() {
                let data = {
                    optionIds: this.optionIds,
                    taskId: sessionStorage.AltizureId
                }
                this.$axios.post(this.URL.uUserTask.select, data).then(res => {

                    if (res.status === 200) {
                        this.optionIds = []
                    }
                })
            },
            repload() {
                if (this.clickBoolean) {
                    this.randomFolder()
                    this.clickBoolean = false
                    let that = this

                    setTimeout(function () {
                        that.clickBoolean = true
                    }, 30000);
                }else{
                    this.clickBoolean = false
                    this.$message.error('点击过于频繁，请稍后再试');
                }

            }
        },
        created() {
            let that = this
            setTimeout(function () {
                that.clickBoolean = true
            }, 30000);
            that.getAssessmentId()
            that.handleMessage()
        },
        watch: {
            $route(to, from) {
                //判断路由跳转地址 ，解决缓存问题
                if (from.path === '/tizure') {
                    this.rule = !this.rule
                }

            },
        }


    }
</script>

<style lang="less" scoped>
    .header-title {
        position: absolute;
        font-size: 18px;
        font-weight: 700;
        margin-left: 100px;
        z-index: 1
    }

    .bottomButton {
        width: 300px;
        position: absolute;
        left: 50%;
        bottom: 0;
        display: flex;
        margin-left: -150px;
        /*div {*/
        /*width: 250px;*/
        /*}*/
    }

    .iframe-content {
        left: 0;
        top: 0;
        position: fixed;
        right: 0;
        bottom: 0;
        div {
            width: 30px;
            height: 30px;
            position: absolute;
            right: 20px;
            top: 20px;
        }
        iframe {
            width: 100%;
            height: 100vh;
        }
    }

    .mdk-main-iframe {
        width: 100%;
        height: 65vh;
        background: url("../../../../static/img/ic01.png") no-repeat;
    }

    .mdk-sheying {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 200px;
        z-index: 2;
        margin-bottom: -200px;
    }

    .mdk-label {
        position: absolute;
        width: 128px !important;
        visibility: hidden;
    }

    .mdk-location {
        position: absolute;
        visibility: hidden;
        font-size: 32px;
        color: #F56C6C;
    }

</style>



// WEBPACK FOOTER //
// src/views/main/assessment/main-assessment.vue